<template>
  <LoginPage v-if="auth.checked && shouldShowLogin" />
  <div v-else-if="!auth.checked" class="app-loading">加载安全状态...</div>
  <div v-else class="app-shell">
    <aside class="sidebar">
      <div class="brand">
        <span class="brand-mark">Q</span>
        <div>
          <strong>QQ Persona</strong>
          <small>Admin Console</small>
        </div>
      </div>
      <nav>
        <RouterLink v-for="item in navItems" :key="item.path" :to="item.path" class="nav-item">
          <span>{{ item.index }}</span>
          <b>{{ item.label }}</b>
        </RouterLink>
      </nav>
    </aside>
    <main class="content">
      <div class="security-strip" v-if="auth.security">
        <span>安全：{{ auth.security.status }}</span>
        <span v-if="auth.session">会话：{{ auth.session.actor }} / {{ formatSeconds(auth.session.seconds_remaining) }}</span>
        <span v-if="auth.security.public_bind_warning">{{ auth.security.message }}</span>
        <button v-if="auth.authenticated" class="button small" @click="auth.logout">退出</button>
      </div>
      <RouterView />
    </main>
    <div class="toast-stack">
      <div v-for="item in toast.items" :key="item.id" class="toast" :class="item.type">
        <span>{{ item.message }}</span>
        <small v-if="item.code || item.status" class="toast-meta">
          <span v-if="item.code">{{ item.code }}</span>
          <span v-if="item.status">HTTP {{ item.status }}</span>
        </small>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterLink, RouterView } from "vue-router";
import { computed, onMounted } from "vue";
import LoginPage from "../pages/LoginPage.vue";
import { useAuthStore } from "../stores/auth";
import { useToastStore } from "../stores/toast";

const toast = useToastStore();
const auth = useAuthStore();
const shouldShowLogin = computed(() => Boolean(auth.authRequired || auth.security?.locked || (auth.security?.admin_auth_enabled && !auth.authenticated)));
const labels = [
  ["01", "/", "概览"],
  ["02", "/personas", "人设"],
  ["03", "/attitudes", "态度"],
  ["04", "/affinity", "好感度"],
  ["05", "/grudges", "记仇"],
  ["06", "/taboos", "禁区"],
  ["07", "/stickers", "表情包"],
  ["08", "/plugins", "插件"],
  ["09", "/learning", "学习"],
  ["10", "/config", "配置"],
  ["11", "/data", "导入"],
  ["12", "/tts", "TTS"],
  ["13", "/qqlogin", "QQ登录"],
  ["14", "/debug", "调试"],
  ["15", "/observability", "监控"],
  ["16", "/chat-analysis", "内容分析"],
  ["17", "/good-stuff", "好东西"],
  ["18", "/project-internal", "project-internal"],
  ["19", "/memory", "记忆"],
  ["20", "/evals", "评测"],
  ["21", "/users", "用户画像"],
  ["22", "/audit", "审计"]
];
const navItems = labels.map(([index, path, label]) => ({ index, path, label }));

function formatSeconds(value: number) {
  const seconds = Math.max(0, Number(value || 0));
  const minutes = Math.floor(seconds / 60);
  if (minutes >= 60) return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
  return `${minutes}m`;
}

onMounted(() => {
  auth.installAuthListeners();
  auth.refresh().catch(() => {
    auth.checked = true;
    auth.authRequired = true;
  });
});
</script>
